import config from '../app/config';

const replaceRedirectUrl = (url, MBPRedirectUrl, IGQRedirectUrl) => {
  if (url) {
    switch (url.toLowerCase()) {
      case "/agents/redirecttombp":
        return MBPRedirectUrl;
      case "/agents/redirecttoigq":
        return IGQRedirectUrl;
      default:
        if(!url.includes("https://") && !url.includes("?brand=") && !url.startsWith('#')){
          if(url.includes("#")){
            var indexPos=url.lastIndexOf("#");
            if(url.includes("?")){
              if(!url.includes("&brand="))
                return url.substring(0,indexPos) + `&brand=${config.brand}` + url.substring(indexPos);
            }else {
              return url.substring(0,indexPos) + `?brand=${config.brand}` + url.substring(indexPos);
            }
          }else{
            if(url.includes("?")){
              if(!url.includes("&brand="))
                return url + `&brand=${config.brand}`
            }
            else {
              return url + `?brand=${config.brand}`
            }
          }
        }
        return url;
    }
  }
  return url;
};

export default replaceRedirectUrl;
export { replaceRedirectUrl };
